var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("columns")))]),
              _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.view.Columns,
                    "disable-x": "",
                    "keep-in-y": "",
                    tag: "w-list",
                    "target-class": "handle",
                  },
                },
                _vm._l(_vm.view.Columns, function (col, i) {
                  return _c(
                    "w-list-item",
                    { key: i, attrs: { "show-handle": "" } },
                    [
                      _c("w-list-item-text", [
                        _c("span", [
                          _vm._v(" " + _vm._s(col.Name) + " "),
                          _c("span", { staticClass: "gray" }, [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.$t(_vm.getColumnFriendlyName(col))) +
                                ")"
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("highlights-edit"),
                                  expression: "$ct('highlights-edit')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editHighlights(col)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "font" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("edit-column"),
                                  expression: "$ct('edit-column')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editColumn(col)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("remove-column"),
                                  expression: "$ct('remove-column')",
                                },
                              ],
                              staticClass: "danger",
                              on: {
                                click: function ($event) {
                                  return _vm.removeColumn(i)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addColumn()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("add-column"))),
                  ]),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.editColumnModal,
                    callback: function ($$v) {
                      _vm.editColumnModal = $$v
                    },
                    expression: "editColumnModal",
                  },
                },
                [
                  _c("app-edit-column", {
                    attrs: {
                      add: _vm.isColumnNew,
                      browse: _vm.browse,
                      column: _vm.editingColumn,
                    },
                    on: { save: _vm.save, cancel: _vm.cancel },
                  }),
                ],
                1
              ),
              _vm.toEditHighlightsColumn
                ? _c(
                    "w-modal",
                    { attrs: { value: "" } },
                    [
                      _c("app-column-hightlights", {
                        attrs: {
                          view: _vm.view,
                          column: _vm.toEditHighlightsColumn,
                        },
                        on: {
                          close: function ($event) {
                            _vm.toEditHighlightsColumn = null
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }